module.exports = __webpack_public_path__ + "static/media/edlight.ee030c0f.png";